import { DateTime } from "luxon/src/luxon";
import React from "react";

interface ModifiedAtColumnProps {
    modifiedAt: string;
}

export const ModifiedAtColumn = ({ modifiedAt }: ModifiedAtColumnProps) => {
    const offset = DateTime.local().offset;
    const renderDate = DateTime.fromISO(modifiedAt).plus({
        hours: offset / 60,
    });
    return (
        <div>
            {renderDate.toLocaleString()}
            <br />
            {renderDate.toLocaleString(DateTime.TIME_24_WITH_SECONDS)}
        </div>
    );
};
